import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getQueryStringFromObject } from '../../../../common';
import { API_URL } from '../../../../services';
import { TransportOrderIdView } from '../../../models';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { ShipmentTransportOrderEndpoint } from '../constants';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderItemService {
  constructor(private http: WrapperHttpService) {}

  getNotificationListCount(transportOrderIdView: TransportOrderIdView): Observable<number> {
    return this.http
      .withLoading()
      .get(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Notifications
        }${ShipmentTransportOrderEndpoint.Count}?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
